import makeStyles from '@material-ui/core/styles/makeStyles';
import { ISpcTheme } from '../../theme/ISpcTheme';

const inputFieldStyles = makeStyles<ISpcTheme>(theme => ({
  root: {
    '& $notchedOutline': {
      borderColor: theme.palette.text.secondary,
      borderWidth: 1,
    },
  },
  fieldWrapper: {
    position: 'relative',
    height: '4.4rem',
    width: '100%',
  },
  input: {
    width: '100%',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(theme.typography.fontMD),
    transition: theme.transitions.create(['border-color', 'box-shadow']),
  },
  notchedOutline: {
    borderRadius: '3px',
    borderColor: theme.palette.text.secondary,
    borderWidth: 1,
  },
  focused: {
    borderColor: theme.palette.primary.main,
    boxShadow: 'inset 0 0 10px 1px rgba(150,184,212,0.5)',
  },
  inputError: {
    borderColor: theme.palette.error.main,
  },
  helperTextError: {
    fontSize: theme.typography.pxToRem(theme.typography.fontMD),
    margin: '1rem',
  },
  inputAdornment: {
    '& svg': {
      stroke: theme.palette.text.secondary,
      strokeWidth: '2px',
    },
  },
}));

export default inputFieldStyles;
